import PropTypes from 'prop-types';
import { hy } from 'date-fns/locale';
// @mui
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';
// hooks
import { Controller, useFormContext } from 'react-hook-form';

RHFDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disabled: PropTypes.bool,
  OpenPickerButtonProps: PropTypes.object,
  inputFormat: PropTypes.string,
};

export default function RHFDatePicker({
  name,
  label,
  disablePast,
  disableFuture,
  disabled,
  OpenPickerButtonProps,
  minDate,
  maxDate,
  inputFormat,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider adapterLocale={hy} dateAdapter={AdapterDateFns}>
          <DatePicker
            {...field}
            label={label}
            mask="____-__-__"
            inputFormat={inputFormat || 'yyyy-MM-dd'}
            views={other.views || ['year', 'month', 'day']}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            disablePast={disablePast}
            disableFuture={disableFuture}
            OpenPickerButtonProps={OpenPickerButtonProps}
            renderInput={(params) => (
              <TextField {...params} name={name} error={!!error} helperText={error?.message} {...other} />
            )}
          />
        </LocalizationProvider>
      )}
    />
  );
}
